(function () {
    const hiddenText = document.querySelector('[data-hidden-text]');
    const switchBtns = document.querySelectorAll('[data-switch-btn]');

    if (hiddenText && switchBtns) {
        switchBtns.forEach(btn => {
            btn.addEventListener('click', e => {
                e.preventDefault();

                switchBtns.forEach(btn => btn.classList.remove('hide'))
                e.target.classList.add('hide');

                hiddenText.classList.toggle('open');
                hiddenText.scrollIntoView({behavior: 'smooth', block: 'start'});
            })
        })
    }
}());

// Check bank transfer weekends
(function () {
    const currentDate = new Date();
    const currentDateTime = new Date(currentDate.toLocaleString('en-US', {timeZone: 'Asia/Colombo'}));
    const dayOfWeek = currentDateTime.getDay();
    const hours = currentDateTime.getHours();

    const commercialBank = document.querySelector('[data-id="commercial-bank"]')
    const isCommercialBankWeekend = (dayOfWeek === 5 && hours >= 10) || dayOfWeek === 6 || dayOfWeek === 0;

    if (commercialBank && isCommercialBankWeekend) {
        commercialBank.style.display = 'none'
    }
}());
